var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c(
        "sweet-modal",
        {
          ref: "modal",
          attrs: {
            "overlay-theme": "dark",
            blocking: "",
            "enable-mobile-fullscreen": false
          }
        },
        [
          _vm.userVerification
            ? [
                _c("img", {
                  directives: [
                    {
                      name: "lazy",
                      rawName: "v-lazy",
                      value: _vm.userVerification.line_image_url,
                      expression: "userVerification.line_image_url"
                    }
                  ],
                  staticClass: "img-fluid",
                  attrs: { alt: "" }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "text-left my-4" }, [
                  _vm._v(_vm._s(_vm.userVerification.line_description))
                ]),
                _vm._v(" "),
                _c("div", [
                  _c(
                    "a",
                    {
                      staticClass: "btn btn-success",
                      attrs: { href: "", target: "_blank" },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.addLine(
                            _vm.userVerification.line_login_url
                          )
                        }
                      }
                    },
                    [_vm._v("GET LINE DISCOUNT")]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "mt-4" }, [
                  _c(
                    "a",
                    {
                      attrs: { href: "" },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.skipAddingLine.apply(null, arguments)
                        }
                      }
                    },
                    [_vm._v("Skip")]
                  )
                ])
              ]
            : _vm._e()
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-248199dc", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-248199dc","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modal/LineVerificationModal.vue
// module id = 1408
// module chunks = 0